import styles from "./undo-cancel-toast.module.scss";
import { useRouter } from "next/navigation";
import { $undoCancelKey } from "@/data/undo-cancel.constants";
import { useABTestUndoCancelContext } from "@/providers/ab-testing-providers/ab-test-undo-cancel-provider";

type Props = {
  close: () => void;
};

const UndoCancelToast = ({ close }: Props) => {
  const router = useRouter();
  const { trackABConversion } = useABTestUndoCancelContext();

  const undoCancelRequestOnClick = () => {
    trackABConversion();
    close();
    router.push("/pricing");
  };

  const noThankOnClick = () => {
    close();
    localStorage.setItem($undoCancelKey, Date.now().toString());
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.info}>
        <h2>Your membership ends today</h2>
        <p>
          Want to stick around? Keep your membership going in one, easy step!
        </p>
      </div>
      <div className={styles.buttons}>
        <div className={styles.no_thanks} onClick={noThankOnClick}>
          NO THANKS
        </div>
        <button onClick={undoCancelRequestOnClick}>UNDO CANCEL REQUEST</button>
      </div>
    </div>
  );
};

export default UndoCancelToast;
